<template>
  <div class="screen-wrapper">
    <div ref="screenRef" class="screen-container" @click="handleOutsideClick">
      <!-- 加载动画 -->
      <div v-if="isLoading" class="loading">
        <div class="loadbox">
          <img src="@/assets/images/loading.gif" />
          页面加载中...
        </div>
      </div>

      <!-- 顶部标题 -->
      <div class="head">
        <h1>{{ marketName }}</h1>
      </div>

      <!-- 主体内容 -->
      <div class="main-content">
        <!-- 左列 25% -->
        <div class="column-left" @click.stop>
          <!-- <IndustryOverview
            :activeComp="activeComp"
            @switchCenter="toggleCenter('IndustryDetail')" /> -->
          <IndustryOverview @openDetail="openIndustryDetail" />
          <DemoBase :activeComp="activeComp" @switchCenter="toggleCenter('BaseDetail')" />
          <ECommerce @openDetail="showMall = true" />
          <TraceManage :activeComp="activeComp" @switchCenter="toggleCenter('TraceDetail')" />
        </div>

        <!-- 渠道推广弹窗 -->
        <div v-if="showMall" class="industry-overlay" @click.stop>
          <EcommerceDetail @closeDetail="showMall = false" />
        </div>

        <!-- 产业概况图表弹窗 -->
        <!-- 弹窗放在 screen-container 里，和 mall-overlay 同级 -->
        <div v-if="showIndustryDetail" class="industry-overlay" @click.stop>
          <IndustryDetail :detailType="industryDetailType" @closeDetail="closeIndustryDetail" />
        </div>

        <!-- 中列 50% -->
        <div class="column-center" @click.stop>
          <div class="center-main">
            <transition name="fade-scale" mode="out-in">
              <keep-alive include="CenterMap">
                <component
                  :is="activeComp"
                  :deliveryImageIndex="deliveryImageIndex"
                  :farmerImageIndex="farmerImageIndex"
                  @goBack="activeComp = 'CenterMap'" />
              </keep-alive>
            </transition>
          </div>

          <!-- <CenterMap /> -->

          <div class="center-bottom-row">
            <!-- <UnifiedMarket :activeComp="activeComp" @switchCenter="toggleCenter('MarketDetail')" /> -->
            <TaxManage :activeComp="activeComp" @switchCenter="toggleCenter('TaxDetail')" />
            <Delivery
              :activeComp="activeComp"
              @switchCenter="onDeliverySwitchCenter"
              @syncIndex="deliveryImageIndex = $event" />
          </div>
        </div>

        <!-- 右列 25% -->
        <div class="column-right" @click.stop>
          <BrandManage />
          <PriceTrend :activeComp="activeComp" @switchCenter="toggleCenter('PriceDetail')" />
          <FarmerCollect
            :activeComp="activeComp"
            @switchCenter="onFarmerSwitchCenter"
            @syncIndex="farmerImageIndex = $event" />
          <SupplyFinance />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseDetail from '@/components/BaseDetail.vue'
import BrandManage from '@/components/BrandManage.vue'
import CenterMap from '@/components/CenterMap.vue'
import Delivery from '@/components/Delivery.vue'
import DeliveryDetail from '@/components/DeliveryDetail.vue'
import DemoBase from '@/components/DemoBase.vue'
import ECommerce from '@/components/ECommerce.vue'
import EcommerceDetail from '@/components/EcommerceDetail.vue'
import FarmerCollect from '@/components/FarmerCollect.vue'
import FarmerDetail from '@/components/FarmerDetail.vue'
import IndustryDetail from '@/components/IndustryDetail.vue'
import IndustryOverview from '@/components/IndustryOverview.vue'
import MarketDetail from '@/components/MarketDetail.vue'
import PriceDetail from '@/components/PriceDetail.vue'
import PriceTrend from '@/components/PriceTrend.vue'
import SupplyFinance from '@/components/SupplyFinance.vue'
import TaxDetail from '@/components/TaxDetail.vue'
import TaxManage from '@/components/TaxManage.vue'
import TraceDetail from '@/components/TraceDetail.vue'
import TraceManage from '@/components/TraceManage.vue'
import UnifiedMarket from '@/components/UnifiedMarket.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'DashboardView',
  components: {
    IndustryOverview,
    DemoBase,
    ECommerce,
    CenterMap,
    UnifiedMarket,
    Delivery,
    SupplyFinance,
    BrandManage,
    PriceTrend,
    TraceManage,
    FarmerCollect,
    MarketDetail,
    EcommerceDetail,
    BaseDetail,
    PriceDetail,
    TaxManage,
    IndustryDetail,
    TraceDetail,
    DeliveryDetail,
    FarmerDetail,
    TaxDetail
  },
  data() {
    return {
      activeComp: 'CenterMap', // 控制中间区域显示的变量
      isLoading: true,
      showMall: false,
      showIndustryDetail: false,
      industryDetailType: 'overview',
      deliveryImageIndex: 0, // 仓储物流传的图片索引
      farmerImageIndex: 0 // 农资采集传的图片索引
    }
  },

  created() {
    this.$store.dispatch('dashboard/startFetching')
  },

  mounted() {
    setTimeout(() => {
      this.isLoading = false
    }, 1500)

    // 页面加载完成后初始化缩放
    this.updateScale()
    // 监听窗口大小变化
    window.addEventListener('resize', this.updateScale)
  },

  beforeDestroy() {
    //销毁前移除监听，防止内存泄漏
    window.removeEventListener('resize', this.updateScale)
    this.$store.dispatch('dashboard/stopFetching')
  },

  computed: {
    ...mapGetters('dashboard', ['marketInfo']),

    marketName() {
      return this.marketInfo.market_name
    }
  },

  methods: {
    updateScale() {
      const screenRef = this.$refs.screenRef
      if (!screenRef) return

      const designWidth = 1920
      const designHeight = 1080

      // 获取当前窗口宽高
      const clientWidth = document.documentElement.clientWidth
      const clientHeight = document.documentElement.clientHeight

      // 计算缩放比例
      const scaleX = clientWidth / designWidth
      const scaleY = clientHeight / designHeight

      screenRef.style.transform = `scale(${scaleX}, ${scaleY}) translate(0, 0)`
    },

    // 点击按钮切换中心视图
    toggleCenter(comp) {
      if (this.activeComp === comp) {
        this.activeComp = 'CenterMap'
      } else {
        this.activeComp = comp
      }
    },

    // 产业概况弹窗
    openIndustryDetail(type = 'overview') {
      this.industryDetailType = type
      this.showIndustryDetail = true
    },

    closeIndustryDetail() {
      this.showIndustryDetail = false
      this.industryDetailType = 'overview'
    },

    // 点击中心视图外部区域，返回到 map
    handleOutsideClick() {
      if (this.activeComp != 'CenterMap') {
        this.activeComp = 'CenterMap'
      }
    },

    // 物流图片传参
    onDeliverySwitchCenter(index) {
      console.log(index)
      this.deliveryImageIndex = index
      // this.toggleCenter('DeliveryDetail')
      this.activeComp = 'DeliveryDetail'
    },

    // 农资图片传参
    onFarmerSwitchCenter(index) {
      console.log(index)
      this.farmerImageIndex = index
      // this.toggleCenter('DeliveryDetail')
      this.activeComp = 'FarmerDetail'
    }
  }
}
</script>

<style>
@import '@/assets/css/global.css';

.mall-overlay {
  position: fixed;
  width: 1920px;
  height: 1080px;

  display: flex;
  justify-content: center;
  align-items: center;

  /* background: rgba(0, 0, 0, 0.4); */
  z-index: 9999;
}

.mall-window {
  width: 800px;
  height: 600px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.mall-header {
  height: 40px;
  background: #0b1c2c;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0 15px;
}

.close-btn {
  color: #83ffe1;
  text-align: right;
  margin: 0 15px;
  cursor: pointer;
}

.mall-frame {
  /* width: 100%;
  height: calc(100% - 40px);
  border: none; */

  position: absolute; /* screen-container 是相对定位的容器 */
  width: 75%;
  height: 80%;
  top: 120px;
  left: 240px;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  background: rgb(1 11 31 / 98%);
  z-index: 999;
  border: 2.4px solid rgb(5 175 211 / 91%);
  box-shadow: 0 0 16px rgba(0, 191, 255, 0.4), inset 0 0 70px rgba(0, 191, 255, 0.5),
    inset 0 0 2px rgba(255, 255, 255, 0.3);
  border-radius: 20px;
}

.mini-image {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: fit-content;
    height: 500px;
  }
}

.industry-overlay {
  position: absolute; /* screen-container 是相对定位的容器 */
  width: 75%;
  height: 80%;
  top: 120px;
  left: 240px;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  background: rgb(1 11 31 / 98%);
  z-index: 999;
  border: 2.4px solid rgb(5 175 211 / 91%);
  box-shadow: 0 0 16px rgba(0, 191, 255, 0.4), inset 0 0 70px rgba(0, 191, 255, 0.5),
    inset 0 0 2px rgba(255, 255, 255, 0.3);
  border-radius: 20px;
}
</style>
